import { rootApi } from 'src/v2/store/api/rootApi'

export const enrollmentCheckerAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    searchEnrollmentChecker: builder.mutation({
      query: (searchTerm) => {
        return {
          url: '/persons/find-enrollment-checker',
          method: 'POST',
          data: {
            phoneNumber: `+1${searchTerm}`,
            tlcNumber: searchTerm,
            driversLicenseNumber: searchTerm,
          },
        }
      },
    }),
  }),
})

export const { useSearchEnrollmentCheckerMutation } = enrollmentCheckerAPI
